import { refEUIngredient } from "@tc/drizzle-v2"
import { eq, and } from "drizzle-orm"
import {
  MessageAttributeValue,
  SQSClient,
  SendMessageCommand,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { EUIngredientDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["EU_INGREDIENTS_QUEUE_URL"]

export const getEUIngredientsData = async (
  tx: DbTransaction,
  id: string,
): Promise<EUIngredientDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refEUIngredient.id,
      ingredient: refEUIngredient.ingredient,
      functionalCategory: refEUIngredient.functionalCategory,
      eNumber: refEUIngredient.eNumber,
      allergen: refEUIngredient.allergen,
      priority: refEUIngredient.priority,
    })
    .from(refEUIngredient)
    .where(
      and(
        eq(refEUIngredient.id, parseInt(id)),
        eq(refEUIngredient.active, true),
      ),
    )

  if (!row) {
    console.error(`EU Ingredient with id ${id} not found/active`)
    return
  }

  const docId = row.functionalCategory
    ? `${row.functionalCategory}/${row.ingredient}`
    : row.ingredient

  const ingredientDoc: EUIngredientDoc = {
    id: docId,
    ingredient: row.ingredient,
    functional_category: row.functionalCategory,
    e_number: row.eNumber,
    allergen: row.allergen,
    priority: row.priority,
  }

  searchBuilderLog.debug({ document: ingredientDoc })

  return ingredientDoc
}

export const saveEUIngredientsToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getEUIngredientsData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
